<template>
  <div v-if="show" class="loader">
    <div class="lds-ring">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Loader',

  props: {
    show: {
      type: Boolean,
      required: true,
    },
  },
};
</script>
<style lang="scss" scoped>
.lds-ring {
  display: inline-block;
  position: relative;
  width: 28px;
  height: 28px;
}
.lds-ring div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 21px;
  height: 21px;
  margin: 4px;
  border: 3px solid #fff;
  border-radius: 50%;
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: #fff transparent transparent transparent;
}
.lds-ring div:nth-child(1) {
  animation-delay: -0.45s;
}
.lds-ring div:nth-child(2) {
  animation-delay: -0.3s;
}
.lds-ring div:nth-child(3) {
  animation-delay: -0.15s;
}
@keyframes lds-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.loader {
  width: 100%;
  height: 50px;
  padding-top: 20px;
  display: inline-flex;
  justify-content: center;

  .lds-ring div {
    border: 3px solid $brand-primary;
    border-color: $brand-primary transparent transparent transparent;
  }
}
</style>
